import { render } from "./LoaderElement.vue?vue&type=template&id=6256dfa9"
import script from "./LoaderElement.vue?vue&type=script&lang=js"
export * from "./LoaderElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__